import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthToken } from "../State/Hooks/authHooks";
import { useUserProfileStore } from "../State/Stores/UserProfileStore";
import { Timezone, UserProfile, UserProfileUpsert } from "../Typings/UserProfile";
import { apiPathUserProfile, secureFetcher } from "./queryHelpers";

export const useTimezonesQuery = () => {
  const token = useAuthToken();
  return useQuery<Timezone[]>(["timezones"], () => secureFetcher(apiPathUserProfile + "timezone", token), {
    enabled: !!token,
    staleTime: 600000,
    cacheTime: 600000,
  });
};

export const useGetUserProfileQuery = (userId: string) => {
  const token = useAuthToken();
  return useQuery<UserProfile | undefined>(
    ["userProfile", userId],
    () => secureFetcher(`${apiPathUserProfile}user/${userId}`, token),
    {
      enabled: !!token && !!userId,
      staleTime: 600000,
      cacheTime: 600000,
      refetchOnWindowFocus: false,
    },
  );
};

export const useSaveUserProfileMutation = () => {
  const token = useAuthToken();
  const queryClient = useQueryClient();
  const { setProfile } = useUserProfileStore();

  return useMutation<UserProfile, unknown, UserProfileUpsert>(
    (data) => {
      return secureFetcher(`${apiPathUserProfile}user/${data.userAuthId}`, token, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    {
      onSuccess: (data) => {
        setProfile(data);
        queryClient.setQueryData(["userProfile", data.userAuthId], data);
      },
      mutationKey: ["saveUserProfile"],
    },
  );
};
